import { useState } from 'react';
import BooleanValue from '@components/booleanValue/BooleanValue';
import { VerifyButton } from '@routes/adminRoutes/sharedComponents/SharedStyledComponents';
import { adminApproveUser } from '@utils/api';
import { useToast } from '@contexts/Toast.context';
import { useConfirm } from '@contexts/Confirm.context';

const ApproveUser = ({ cellValue, email }) => {
	const { addToast } = useToast();
	const { confirm } = useConfirm();
	const [approve, setApproved] = useState(cellValue);

	const handleApprove = async () => {
		const userConfirmed = await confirm({
			title: 'Approve User',
			message: (
				<>
					Are you sure you want to approve <strong>{email}</strong>?
				</>
			),
		});

		if (userConfirmed) {
			try {
				const response = await adminApproveUser(email);
				if (response?.status === 'success') {
					setApproved(true);
					addToast({
						id: 'approve-user-success',
						bg: 'success',
						title: 'User is approved.',
					});
				} else {
					addToast({
						id: 'approve-user-error',
						bg: 'danger',
						title: 'Failed to approve user.',
					});
				}
			} catch (err) {
				console.error('Failed to approve user', err);
				addToast({
					id: 'approve-user-error',
					bg: 'danger',
					title: 'Failed to approve user.',
				});
			}
		}
	};

	return (
		<>
			<BooleanValue value={approve} />

			{!approve && (
				<VerifyButton size="sm" onClick={handleApprove}>
					Approve
				</VerifyButton>
			)}
		</>
	);
};

export default ApproveUser;
